<template>

    <animated-number
        :value="value"
        :formatValue="roundUp"
        :duration="totalDuration"></animated-number>

</template>

<script>
    import AnimatedNumber from "animated-number-vue";

    export default {
        name: 'MsAnimatedNumber',
        components: {AnimatedNumber},

        props: {
            value: {
                type: String,
                required: true
            },
            duration: {
                type: Number,
                required: false,
                default: 2000
            }
        },

        computed: {
            totalDuration() {
                return this.duration + (Math.ceil(parseFloat(this.value)));
            }
        },

        methods: {
            roundUp(val) {
                val = parseFloat(val);
                return `${Math.ceil(val)}`;
            }
        }
    }
</script>
